export const languages = [
  {
    code: 'lt',
    name: 'Lietuvių',
    image: require('@/assets/images/flags/lt.svg'),
  },
  {
    code: 'en',
    name: 'English',
    image: require('@/assets/images/flags/en.svg'),
  },
  {
    code: 'uk',
    name: 'Українською',
    image: require('@/assets/images/flags/uk.svg'),
  },
  {
    code: 'pl',
    name: 'Polski',
    image: require('@/assets/images/flags/pl.svg'),
  },
  {
    code: 'lv',
    name: 'Latviešu',
    image: require('@/assets/images/flags/lv.svg'),
  },
  {
    code: 'de',
    name: 'Deutsch',
    image: require('@/assets/images/flags/de.svg'),
  },
  {
    code: 'ru',
    name: 'Русский',
    image: require('@/assets/images/flags/ru.svg'),
  },
  {
    code: 'ro',
    name: 'Română',
    image: require('@/assets/images/flags/ro.svg'),
  },
  {
    code: 'et',
    name: 'Eesti',
    image: require('@/assets/images/flags/et.svg'),
  },
  {
    code: 'nl',
    name: 'Nederlands',
    image: require('@/assets/images/flags/nl.svg'),
  },
];

export const getLanguageByCode = code =>
  languages.find(language => language.code === code);
